var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.activeEmployeePermissions
    ? _c("div", { staticClass: "container", attrs: { role: "main" } }, [
        _c(
          "article",
          [
            _c("h1", { staticClass: "mb-4" }, [
              _vm._v(_vm._s(_vm.$t("pages.permission.title"))),
            ]),
            _c("card-data-component", {
              attrs: { tabs: _vm.tabs, currentTabKey: _vm.tabKey },
              on: _vm._d({}, [_vm.tabChangedEvent, _vm.tabChanged]),
              scopedSlots: _vm._u(
                [
                  {
                    key: "data",
                    fn: function (props) {
                      return [
                        _vm.isVacation(props.tab.key)
                          ? _c("vacation-tab")
                          : _vm._e(),
                        _vm.isAbsence(props.tab.key)
                          ? _c("absence-tab")
                          : _vm._e(),
                        _vm.isPermissionTab(props.tab.key)
                          ? _c("permission-list-tab")
                          : _vm._e(),
                      ]
                    },
                  },
                ],
                null,
                false,
                1938122002
              ),
            }),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }